<template>
  <div class="pagination">
    <button :disabled="currentPage <= 1" class="btn btn-light" @click="prevPage()">Prev</button>
    <span class="current-page">Page {{ currentPage }}</span>
    <button :disabled="from + size >= total" class="btn btn-light" @click="nextPage()">Next</button>
  </div>
</template>
<script>
  export default {
    props: [
      "size",
      "from",
      "total",
      "currentPage"
    ],
    data() {
      return {
      }
    }
    , methods: {
      nextPage(){
        let from = parseInt(this.from);
        from = from + parseInt(this.size);
        this.$eventBus.emit('page-change', from);
      },
      prevPage() {
        let from = parseInt(this.from);
        from = from - parseInt(this.size);
        from = (from < 1) ? 0 : from;
        this.$eventBus.emit('page-change', from);
      }
    }
  }
</script>
